import store from '@/store/index.js';
import pixNProgress from '@/shared/pixNProgress.js';

const mandatePropertyGuard = async (to, from, next) => {
  try {
    await store.dispatch('mandatePropertyModule/fetchPropertyById', to.params.propertyId);
    next();
  } catch (error) {
    store.dispatch('toastModule/error', 'Error loading property');
    pixNProgress.forceFinish();
    next(false);
  }
};

export default mandatePropertyGuard;
